import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { dateFormat } from "../../../utils/date";

const gdprQuestion = [
  { label: "To store details & documents", value: "John" },
  { label: "To share relevant Details with third parties", value: "Brahim" },
  { label: "To receive service communications", value: "Developer" },
  {
    label: "To receive market communications",
    value: "HTML,  JavaScript,  PHP",
  },
];

const CandidateGDPR = ({ formData, handleInputChange, submit, isView, close }) => {

  const [gdpr, setgdpr] = useState([{ qNo: 1 }, { qNo: 2 }, { qNo: 3 }, { qNo: 4 }]);

  useEffect(()=>{
    if(formData?.gdpr && formData?.gdpr?.length > 0) {
      setgdpr(formData?.gdpr)
    }
  },[formData])

  const formatDate = (date) => {
    date = new Date(date);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";

    const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;
    return `${dateFormat(date)} ${formattedTime}`;
  };

  // const gdpr =
  //   formData?.gdpr && formData?.gdpr?.length === 4
  //     ? formData?.gdpr
  //     : [{ qNo: 1 }, { qNo: 2 }, { qNo: 3 }, { qNo: 4 }];

   //   const gdpr = [{ qNo: 1 }, { qNo: 2 }, { qNo: 3 }, { qNo: 4 }];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-3 col-lg-4">
            <div className="clearfix">
              <div className="card card-bx profile-card author-profile m-b30">
                <div className="card-body">
                  <div className="info-list">
                    <ul>
                      <li>
                        <button className="btn btn-primary me-1" disabled >
                          Send GDPR Letter
                        </button>
                      </li>
                      <li>
                        <button className="btn btn-primary me-1" disabled>
                          Data Request Received
                        </button>
                      </li>
                      <li>
                        <button className="btn btn-primary me-1" disabled>
                          Data Request Processed
                        </button>
                      </li>
                      <li>
                        <button className="btn btn-primary me-1" disabled>
                          Removal Request Received
                        </button>
                      </li>
                      <li>
                        <button className="btn btn-primary me-1" disabled>
                          Removal Request Processed
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="card-footer">
                                    <div className="input-group mb-3">
                                        <div className="form-control rounded text-center bg-white">Portfolio</div>
                                    </div>
                                    <div className="input-group">
                                        <a href="https://www.dexignzone.com/" target="blank" className="form-control text-primary rounded text-start bg-white">https://www.dexignzone.com/</a>
                                    </div>
                                </div> */}
              </div>
            </div>
          </div>
          <div className="col-xl-9 col-lg-8">
            <div className="card profile-card card-bx m-b30">
              <div className="card-header">
                <h6 className="title">Consent By this person</h6>
              </div>
                <div className="card-body">
                  <div className="row">
                    <table>
                      <tr>
                        <th></th>
                        <th>Last Consent On</th>
                        <th>Last Revoked On</th>
                      </tr>

                      {gdprQuestion.map((item, ind) => (
                        <tr>
                          <td>
                            <div className="form-check custom-checkbox mb-2">
                              <label
                                className="form-check-label"
                                htmlFor="same-address"
                              >
                                {item.label}
                              </label>
                              <input
                              id={`gdpr-${ind}`}
                                type="checkbox"
                                disabled={isView}
                                checked={gdpr[ind].checked}
                                //value={gdpr[ind].checked}
                                className="form-check-input"
                                onChange={(e) => {
                                  gdpr[ind].checked = !gdpr[ind].checked;
                                  if (gdpr[ind].checked) {
                                    gdpr[ind].consentOn = new Date();
                                  } else {
                                    gdpr[ind].revoledOn = new Date();
                                  }
                                  console.log(gdpr)
                                  setgdpr(gdpr);
                                  handleInputChange("gdpr", gdpr);
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <p>
                              {gdpr[ind].consentOn
                                ? formatDate(gdpr[ind].consentOn)
                                : ""}
                            </p>
                          </td>
                          <td>
                            <p>
                              {gdpr[ind].revoledOn
                                ? formatDate(gdpr[ind].revoledOn)
                                : ""}{" "}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                </div>
                <div className="card-footer">
                  {isView ? null : (
                    <button className="btn btn-primary" onClick={submit}>
                      Save
                    </button>
                  )}
                  <button
                  type="button"
                          onClick={() => {
                            close()
                          }}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CandidateGDPR;
